import { cn } from "~/utils/fontsConfig";

export const BASE_INPUT_STYLES = cn(
    "appearance-none",
    "flex",
    "min-h-[40px]",
    "w-[99.5%]",
    "rounded-md",
    "border",
    "border-v3-N-500",
    "bg-v3-N-500",
    "px-3",
    "py-2",
    "text-sm",
    "file:border-0",
    "file:bg-transparent",
    "file:text-sm",
    "file:font-medium",
    "m-[2px]",
    "ml-[4px]",

    "hover:border-v3-N-400",
    "hover:border-[1px]",

    "text-v3-N-200",
    "placeholder:text-v3-N-400",

    "focus-visible:ring-ring",
    "ring-offset-white/10",
    "focus-visible:outline-none",
    "focus-visible:ring-1",
    "focus-visible:ring-offset-1",
    "focus-visible:ring-white/10",

    "disabled:cursor-not-allowed",
    "disabled:opacity-70",
);
